import styled from "styled-components";
import {JACKPOT_WIDGET_LAYOUT} from "../../../jackpot-widget.component";

interface IJackpotWidgetAmountContainerProps {
    layout: JACKPOT_WIDGET_LAYOUT;
    isDaily: boolean;
}

export const JackpotWidgetAmountContainerDefaultBox = styled.div<IJackpotWidgetAmountContainerProps>`
    width: ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE ? "40%" : "initial"};
`;
